import { Grid, Stack, Stepper, useMantineTheme } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import { useCallback, useState } from 'react'

import airdropImage from '@/assets/webp_converted/airdropTab.webp'
import ConnectMiddleware from '@/plugins/auth/RouteRedirectors/ConnectMiddleware'
import { BodyStack } from '@/styled/components'

import BackButton from '../Buttons/BackButton'
import HelpDrawer from '../HelpDrawer/HelpDrawer'
import Lamina1Logo from '../Lamina1Logo'
import CheckHubAirdrop from './CheckHubAirdop'
import CompletedAirdrop from './CompletedAirdrop'
import LinkDiscordAirdrop from './LinkDiscordAirdrop'
import RewardsAirdrop from './RewardsAirdrop'
import StartAirdrop from './StartAirdrop'

const STEPS = ['START', 'CHECK HUB', 'CHECK DISCORD', 'COMPLETE CLAIM']
const NUM_STEPS = STEPS.length

const Component: React.FC = () => {
  const theme = useMantineTheme()
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`)
  // Stepper
  const [activeStep, setActiveStep] = useState<number>(0)
  const prevStep = useCallback(
    () => setActiveStep(current => (current > 0 ? current - 1 : current)),
    [setActiveStep]
  )
  const nextStep = useCallback(
    () => setActiveStep(current => (current < NUM_STEPS ? current + 1 : current)),
    [setActiveStep, NUM_STEPS]
  )

  return (
    <ConnectMiddleware>
      <Lamina1Logo />
      <Grid>
        <Grid.Col span={{ base: 12, md: 'content', lg: 'auto' }}>
          <BodyStack style={{ marginLeft: '25px', marginRight: '25px' }}>
            <BackButton exit navTo="/home" />
            <Stack
              style={{
                flexDirection: 'row',
                maxWidth: '480px',
                margin: '5px 5px 30px',
              }}
            >
              <Stepper
                color={theme.colors.l1Primary[0]}
                size="sm"
                iconSize={12}
                active={activeStep}
                onStepClick={setActiveStep}
                allowNextStepsSelect={false}
              >
                <Stepper.Step label={STEPS[0]} icon={<></>}>
                  <StartAirdrop nextStep={nextStep} />
                </Stepper.Step>
                <Stepper.Step label={STEPS[1]} icon={<></>}>
                  <CheckHubAirdrop nextStep={nextStep} />
                </Stepper.Step>
                <Stepper.Step label={STEPS[2]} icon={<></>}>
                  <LinkDiscordAirdrop prevStep={prevStep} nextStep={nextStep} />
                </Stepper.Step>
                <Stepper.Step label={STEPS[3]} icon={<></>}>
                  <RewardsAirdrop prevStep={prevStep} nextStep={nextStep} />
                </Stepper.Step>
                <Stepper.Completed>
                  <CompletedAirdrop />
                </Stepper.Completed>
              </Stepper>
            </Stack>
          </BodyStack>
        </Grid.Col>
        <Grid.Col
          span="auto"
          style={{
            backgroundImage: `url(${airdropImage})`,
            backgroundSize: 'cover',
            display: isMobile ? 'none' : 'block',
            minHeight: '100vh',
          }}
        />
      </Grid>
      <HelpDrawer id="airdrop" />
    </ConnectMiddleware>
  )
}
Component.displayName = 'Airdrop'

// eslint-disable-next-line import/prefer-default-export
export { Component }
